import defMsgs from './sk'

const msgs = {
  'PresentationDetail.tab.detail': 'Detail',
  'PresentationDetail.tab.notes': 'Poznámky',
  'PresentationDetail.tab.chat': 'Chat',
  'PresentationNotes.title': 'Poznámky ku prezentaci',
  'PresentationNotes.hint': 'Poznámky se ukládají automaticky',
  'PresentationNotes.shareMail': 'Pošli poznámky mailem',
  'ReportProblemPage.submitButton': 'Nahlásit problém',
  'NewVersionPrompt.message': 'Je dostupný nový obsah',
  'NewVersionPrompt.action': 'NAČÍST',
  'addons.Feedback.sent': 'Pošli feedback',
  'addons.Feedback.sentOk': 'Děkujeme za feedback',
  'addons.Feedback.sentError': 'Nepovedlo se poslat. Zkuste znovu později.',
  'addons.Chat.loading': 'Chat se načítává...',
  'addons.Chat.error': 'Chyba pri načítávání chatu. Zkuste znova později.',
  'addons.Chat.offline': 'Chat se načítá, když budete online.',
}

const cz = Object.assign({}, defMsgs, msgs)

export default cz



// WEBPACK FOOTER //
// ./src/intl/messages/cz.js